import type { FaireProductEntity } from "../../entity_types/product";

export const p_p276vprpdm: FaireProductEntity = {
  token: "p_p276vprpdm",
  type: "product",
  name: "Zen Resonance Singing Bowl",
  brandToken: "b_fpfqb8hgs8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/616a672e97f1bb02d12faeadc60520eacb33b4ff002d8d84e4bd83e5fe45c2be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/986844b73fa26952dd84dfbfb13305ed083fd5405401a27123b1f3fe4b8091f4.jpeg",
    "https://cdn.faire.com/fastly/446e42a7314f5e81a9a75518ae2154e1ddd1d3e45a2a914b3b17543ae224575f.jpeg",
    "https://cdn.faire.com/fastly/a0d819bfcfecf505cd787d14ce06a9a884720d55f5e63ce7974664d875aa94f0.jpeg",
  ],
  priceDollars: 44,
  description:
    "Discover serenity with our Zen Resonance Singing Bowl, inscribed with the sacred Tibetan mantra 'Om Mani Padme Hum'.\n\nIts soothing vibrations envelop you in tranquility, fostering deep meditation and inner harmony.\n\nComes with a wooden striker.\n\nSold as an assortment.\n\nSize\nBowl: 5.45” (Base Diameter) x 3.15” H\nStriker: 5.80”L x 1.25” W\n\nWeight: 2lb 6oz\nMaterial: Brass, and Mixed Alloy\n\nHandmade in India by our fair trade artisan partners.\n\n",
  tags: [],
  msrpDollars: 88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:12.407Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
